import { z } from "zod";

export const registerICafePayloadSchema = z.object({
  emailAddress: z.string(),
  companyName: z.string(),
  phoneNumber: z.string(),
  bizOwnerRegisterNumber: z.string(),
  bizRegisterDate: z.string(),
  bizType: z.string(),
  bizItem: z.string(),
  businesslicenseName: z.string(),
  workZipCode: z.string(),
  workBasicAddress: z.string(),
  workDetailAddress: z.string(),
  postZipCode: z.string(),
  postBasicAddress: z.string(),
  postDetailAddress: z.string(),
  mngAppCode: z.number(),
  franchiseCode: z.number(),
  pcCnt: z.number(),
  hardwareID_CPU: z.string(),
  hardwareID_GraphicChipset: z.string(),
  hardwareID_HDD: z.string(),
  hardwareID_RAM: z.string(),
  osCode: z.number(),
  lineCompanyCode: z.number(),
  lineGoodsCode: z.number(),
  managerMobilePhoneNumber: z.string(),
  managerMobileMarketingPolicyAgree: z.boolean(),
});

export type RegisterICafePayloadType = z.infer<typeof registerICafePayloadSchema>;
